// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var DateUtils = require("../../../shared/src/DateUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var BrowserComponents_Icon = require("./BrowserComponents_Icon.bs.js");
var BrowserComponents_Button = require("./BrowserComponents_Button.bs.js");
var BrowserComponents_FlexRow = require("./BrowserComponents_FlexRow.bs.js");
var BrowserComponents_FlexColumn = require("./BrowserComponents_FlexColumn.bs.js");
var CommonTypes_ResponsiveLayout = require("../../../shared/src/types/CommonTypes_ResponsiveLayout.bs.js");

var wrapper = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems("center"),
      tl: /* [] */0
    });

var container = Curry._1(BrowserStyle.merge, {
      hd: Curry._1(BrowserStyle.style, {
            hd: BrowserStyle.display(BrowserStyle.grid),
            tl: {
              hd: BrowserStyle.gridTemplateColumns({
                    hd: {
                      NAME: "repeat",
                      VAL: [
                        {
                          NAME: "num",
                          VAL: 7
                        },
                        {
                          NAME: "fr",
                          VAL: 1.0
                        }
                      ]
                    },
                    tl: /* [] */0
                  }),
              tl: {
                hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
                tl: {
                  hd: BrowserStyle.gridRowGap(BrowserStyle.rem(0.25)),
                  tl: {
                    hd: BrowserStyle.gridColumnGap(BrowserStyle.rem(0.25)),
                    tl: {
                      hd: BrowserStyle.padding2("zero", BrowserStyle.pct(2.0)),
                      tl: {
                        hd: BrowserStyle.marginBottom(BrowserStyle.rem(1.0)),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }),
      tl: /* [] */0
    });

var calendarHeader = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.alignSelf(BrowserStyle.stretch),
        tl: {
          hd: BrowserStyle.justifyContent(BrowserStyle.spaceBetween),
          tl: {
            hd: BrowserStyle.paddingLeft(BrowserStyle.Spacing.medium),
            tl: {
              hd: BrowserStyle.paddingRight(BrowserStyle.Spacing.medium),
              tl: /* [] */0
            }
          }
        }
      }
    });

function arg(param, param$1) {
  return BrowserStyle.withFont(param, param$1, /* Large */4, /* Bold */2);
}

var calendarTitle = Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined), {
          hd: BrowserStyle.flex({
                NAME: "num",
                VAL: 1.0
              }),
          tl: {
            hd: BrowserStyle.flexBasis(BrowserStyle.pct(10.0)),
            tl: {
              hd: BrowserStyle.overflow("hidden"),
              tl: {
                hd: BrowserStyle.marginTop(BrowserStyle.rem(1.0)),
                tl: {
                  hd: BrowserStyle.marginBottom(BrowserStyle.rem(0.0)),
                  tl: {
                    hd: BrowserStyle.marginLeft(BrowserStyle.pct(2.0)),
                    tl: {
                      hd: BrowserStyle.marginRight(BrowserStyle.pct(2.0)),
                      tl: {
                        hd: BrowserStyle.display("flex"),
                        tl: {
                          hd: BrowserStyle.justifyContent("center"),
                          tl: {
                            hd: BrowserStyle.mobileMedia(BrowserStyle.withFont(undefined, undefined, /* Small */2, undefined)(/* [] */0)),
                            tl: {
                              hd: BrowserStyle.color({
                                    TAG: /* Grey */2,
                                    _0: /* Medium */2
                                  }),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }));

function calendarDay(day, isSelected, isSelectable) {
  var arg = function (param, param$1) {
    return BrowserStyle.withFont(param, param$1, /* XLarge */5, /* Bold */2);
  };
  return Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined), {
                  hd: BrowserStyle.border(BrowserStyle.rem(0.0625), "solid", isSelectable ? (
                          isSelected ? ({
                                TAG: /* Teal */6,
                                _0: /* Medium */2
                              }) : ({
                                TAG: /* Grey */2,
                                _0: /* Light */3
                              })
                        ) : ({
                            TAG: /* Grey */2,
                            _0: /* Lightest */4
                          })),
                  tl: {
                    hd: BrowserStyle.borderRadius(BrowserStyle.Input.borderRadius),
                    tl: {
                      hd: BrowserStyle.backgroundColor(isSelected ? ({
                                TAG: /* Teal */6,
                                _0: /* Medium */2
                              }) : (
                              day > 5 || day < 1 ? ({
                                    TAG: /* White */7,
                                    _0: /* Dark */0
                                  }) : ({
                                    TAG: /* White */7,
                                    _0: /* Light */2
                                  })
                            )),
                      tl: {
                        hd: BrowserStyle.color(isSelectable ? (
                                isSelected ? ({
                                      TAG: /* White */7,
                                      _0: /* Light */2
                                    }) : ({
                                      TAG: /* Grey */2,
                                      _0: /* Dark */1
                                    })
                              ) : ({
                                  TAG: /* Grey */2,
                                  _0: /* Lightest */4
                                })),
                        tl: {
                          hd: BrowserStyle.cursor(isSelectable ? "pointer" : "default"),
                          tl: {
                            hd: BrowserStyle.paddingTop(BrowserStyle.Spacing.medium),
                            tl: {
                              hd: BrowserStyle.paddingBottom(BrowserStyle.Spacing.medium),
                              tl: {
                                hd: BrowserStyle.justifyContent("center"),
                                tl: {
                                  hd: BrowserStyle.textDecoration(isSelectable ? "none" : "lineThrough"),
                                  tl: {
                                    hd: BrowserStyle.transitions({
                                          hd: Curry._4(BrowserStyle.Transition.shorthand, 150, undefined, BrowserStyle.easeIn, "background"),
                                          tl: {
                                            hd: Curry._4(BrowserStyle.Transition.shorthand, 150, undefined, BrowserStyle.easeIn, "color"),
                                            tl: /* [] */0
                                          }
                                        }),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }));
}

var offset = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.flexBasis(BrowserStyle.pct(9.0)),
        tl: {
          hd: BrowserStyle.margin2(BrowserStyle.rem(1.0), BrowserStyle.pct(2.125)),
          tl: {
            hd: BrowserStyle.display("flex"),
            tl: /* [] */0
          }
        }
      }
    });

function arg$1(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* XXLarge */6, /* Bold */2);
}

var monthText = Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined), {
          hd: BrowserStyle.margin(BrowserStyle.auto),
          tl: /* [] */0
        }));

var Styles = {
  wrapper: wrapper,
  container: container,
  calendarHeader: calendarHeader,
  calendarTitle: calendarTitle,
  calendarDay: calendarDay,
  offset: offset,
  monthText: monthText
};

function createOffset(param) {
  return param;
}

function getLuxonDateFromCalendarMonth(param) {
  return DateUtils.getLuxonDate(new Date(param.year, DateUtils.Month.toInt(param.month)));
}

function getOffsetElements(keyPrefix, __x) {
  return Relude_List.makeWithIndex(__x, (function (offsetIndex) {
                return React.createElement("div", {
                            key: keyPrefix + ("-" + Relude_Int.toString(offsetIndex))
                          });
              }));
}

function getOffsetElementsForMonthStart(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(getLuxonDateFromCalendarMonth, DateUtils.monthStartsOn, param);
                            }), createOffset, param);
              }), (function (param) {
                return getOffsetElements("start", param);
              }), param);
}

function getOffsetElementsForMonthEnd(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great((function (param) {
                                            return Relude_Globals.$great$great(getLuxonDateFromCalendarMonth, DateUtils.monthStartsOn, param);
                                          }), createOffset, param);
                            }), (function (param) {
                              return /* Saturday */6 - param | 0;
                            }), param);
              }), (function (param) {
                return getOffsetElements("end", param);
              }), param);
}

function isSelectedDay(param) {
  return Curry._2(DateUtils.eq, param, /* Day */4);
}

function getDayElement(isSelected, toggleSelected, day) {
  var arg = new Date();
  var isAfterToday = DateUtils.isGreaterThanOrEqualTo(undefined, /* Day */4, arg)(day.toJSDate());
  var partial_arg = isAfterToday ? toggleSelected : Relude_IO.pure(undefined);
  return React.createElement(ReactUtils.WithTestId.make, {
              id: "Calendar-" + Relude_Int.toString(DateUtils.getDayFromLuxon(day)),
              children: React.createElement(BrowserComponents_Button.Base.make, {
                    children: React.createElement(ReactUtils.S.make, {
                          children: Relude_Int.toString(DateUtils.getDayFromLuxon(day))
                        }),
                    className: calendarDay(DateUtils.getDayOfTheWeek(day), isSelected, isAfterToday),
                    disabled: Relude_Globals.inverse(isAfterToday),
                    onClick: (function (param) {
                        return Relude_Globals.$$const(partial_arg, param);
                      }),
                    key: day.toISO()
                  })
            });
}

function partial_arg(eta) {
  return Curry._3(DateUtils.eq, undefined, /* Day */4, eta);
}

function isDaySelected(param) {
  return Relude_Globals.$great$great(partial_arg, Relude_List.any, param);
}

function toggleSelectedDay(selectedDates, day) {
  if (!Curry._2(isDaySelected, day, selectedDates)) {
    return Relude_List.append(day, selectedDates);
  }
  var partial_arg = /* Day */4;
  return Relude_List.filterNot(function (param) {
                return DateUtils.eq(undefined, partial_arg, day, param);
              })(selectedDates);
}

function getDaysToDisplay(selectedDates, setSelectedDates, calendarMonth) {
  var year = calendarMonth.year;
  var month = calendarMonth.month;
  var __x = DateUtils.getDaysInMonth(getLuxonDateFromCalendarMonth(calendarMonth));
  return React.createElement(ReactUtils.L.make, {
              children: Relude_List.map(function (day) {
                      return React.createElement(React.Fragment, {
                                  children: getDayElement(Curry._2(Relude_List.any, (function (param) {
                                              return DateUtils.eq(undefined, undefined, day, param);
                                            }), selectedDates), Curry._1(setSelectedDates, toggleSelectedDay(selectedDates, day)), DateUtils.getLuxonDate(day)),
                                  key: day.toISOString()
                                });
                    })(Relude_List.makeWithIndex(__x, (function (day) {
                          return new Date(Relude_Int.toFloat(year), Relude_Int.toFloat(DateUtils.Month.toInt(month)), Relude_Int.toFloat(day + 1 | 0));
                        })))
            });
}

function doCalendarMonthStep(param) {
  if (param[0]) {
    var match = param[1];
    var year = match.year;
    var month = match.month;
    if (Curry._2(DateUtils.Month.eq, DateUtils.Month.bottom, month)) {
      return {
              month: DateUtils.Month.top,
              year: year - 1 | 0
            };
    } else {
      return {
              month: DateUtils.Month.prev(month),
              year: year
            };
    }
  }
  var match$1 = param[1];
  var year$1 = match$1.year;
  var month$1 = match$1.month;
  if (Curry._2(DateUtils.Month.eq, DateUtils.Month.top, month$1)) {
    return {
            month: DateUtils.Month.bottom,
            year: year$1 + 1 | 0
          };
  } else {
    return {
            month: DateUtils.Month.next(month$1),
            year: year$1
          };
  }
}

function dateToCalendarMonth(param) {
  return Relude_Globals.$great$great(DateUtils.getLuxonDate, (function (date) {
                return {
                        month: DateUtils.Month.fromLuxon(date),
                        year: DateUtils.getYearFromLuxon(date)
                      };
              }), param);
}

function isMobile(param) {
  return CommonTypes_ResponsiveLayout.eq(/* Mobile */0, param);
}

function BrowserComponents_Calendar$Stateless(Props) {
  var calendarMonth = Props.calendarMonth;
  var layout = Props.layout;
  var selectedDates = Props.selectedDates;
  var setCalendarMonth = Props.setCalendarMonth;
  var setSelectedDates = Props.setSelectedDates;
  var testId = Props.testId;
  var tmp = {
    children: React.createElement(BrowserComponents_FlexColumn.make, {
          className: wrapper,
          children: null
        }, React.createElement(BrowserComponents_FlexRow.make, {
              className: calendarHeader,
              children: null
            }, React.createElement(BrowserComponents_Button.Base.make, {
                  children: React.createElement(BrowserComponents_Icon.make, {
                        icon: {
                          TAG: /* Small */1,
                          _0: {
                            TAG: /* Arrow */0,
                            _0: /* ArrowLeft */7
                          }
                        },
                        size: /* Large */3
                      }),
                  onClick: (function (param) {
                      return Curry._1(setCalendarMonth, doCalendarMonthStep([
                                      /* Decrement */1,
                                      calendarMonth
                                    ]));
                    }),
                  testId: "CalendarLeftArrow"
                }), React.createElement("h3", {
                  className: monthText
                }, React.createElement(ReactUtils.S.make, {
                      children: Relude_String.toUpperCase(DateUtils.getMonthNameFromLuxon(getLuxonDateFromCalendarMonth(calendarMonth))) + (" " + Relude_Int.toString(calendarMonth.year))
                    })), React.createElement(BrowserComponents_Button.Base.make, {
                  children: React.createElement(BrowserComponents_Icon.make, {
                        icon: {
                          TAG: /* Small */1,
                          _0: {
                            TAG: /* Arrow */0,
                            _0: /* ArrowRight */8
                          }
                        },
                        size: /* Large */3
                      }),
                  onClick: (function (param) {
                      return Curry._1(setCalendarMonth, doCalendarMonthStep([
                                      /* Increment */0,
                                      calendarMonth
                                    ]));
                    }),
                  testId: "CalendarRightArrow"
                })), React.createElement("div", {
              className: container
            }, React.createElement("div", {
                  className: calendarTitle
                }, React.createElement(ReactUtils.S.make, {
                      children: CommonTypes_ResponsiveLayout.eq(/* Mobile */0, layout) ? "S" : "SUN"
                    })), React.createElement("div", {
                  className: calendarTitle
                }, React.createElement(ReactUtils.S.make, {
                      children: CommonTypes_ResponsiveLayout.eq(/* Mobile */0, layout) ? "M" : "MON"
                    })), React.createElement("div", {
                  className: calendarTitle
                }, React.createElement(ReactUtils.S.make, {
                      children: CommonTypes_ResponsiveLayout.eq(/* Mobile */0, layout) ? "T" : "TUE"
                    })), React.createElement("div", {
                  className: calendarTitle
                }, React.createElement(ReactUtils.S.make, {
                      children: CommonTypes_ResponsiveLayout.eq(/* Mobile */0, layout) ? "W" : "WED"
                    })), React.createElement("div", {
                  className: calendarTitle
                }, React.createElement(ReactUtils.S.make, {
                      children: CommonTypes_ResponsiveLayout.eq(/* Mobile */0, layout) ? "T" : "THU"
                    })), React.createElement("div", {
                  className: calendarTitle
                }, React.createElement(ReactUtils.S.make, {
                      children: CommonTypes_ResponsiveLayout.eq(/* Mobile */0, layout) ? "F" : "FRI"
                    })), React.createElement("div", {
                  className: calendarTitle
                }, React.createElement(ReactUtils.S.make, {
                      children: CommonTypes_ResponsiveLayout.eq(/* Mobile */0, layout) ? "S" : "SAT"
                    })), React.createElement(ReactUtils.L.make, {
                  children: getOffsetElementsForMonthStart(calendarMonth)
                }), getDaysToDisplay(selectedDates, setSelectedDates, calendarMonth), React.createElement(ReactUtils.L.make, {
                  children: getOffsetElementsForMonthEnd(calendarMonth)
                })))
  };
  if (testId !== undefined) {
    tmp.id = Caml_option.valFromOption(testId);
  }
  return React.createElement(ReactUtils.WithTestId.make, tmp);
}

var Stateless = {
  createOffset: createOffset,
  getLuxonDateFromCalendarMonth: getLuxonDateFromCalendarMonth,
  getOffsetElements: getOffsetElements,
  getOffsetElementsForMonthStart: getOffsetElementsForMonthStart,
  getOffsetElementsForMonthEnd: getOffsetElementsForMonthEnd,
  isSelectedDay: isSelectedDay,
  getDayElement: getDayElement,
  isDaySelected: isDaySelected,
  toggleSelectedDay: toggleSelectedDay,
  getDaysToDisplay: getDaysToDisplay,
  doCalendarMonthStep: doCalendarMonthStep,
  dateToCalendarMonth: dateToCalendarMonth,
  isMobile: isMobile,
  make: BrowserComponents_Calendar$Stateless
};

function BrowserComponents_Calendar(Props) {
  var initialSelectedDatesOpt = Props.initialSelectedDates;
  var layoutOpt = Props.layout;
  var onUpdate = Props.onUpdate;
  var testId = Props.testId;
  var initialSelectedDates = initialSelectedDatesOpt !== undefined ? initialSelectedDatesOpt : /* [] */0;
  var layout = layoutOpt !== undefined ? layoutOpt : /* Desktop */2;
  var match = ReactIO.useState(function (param) {
        return {
                month: DateUtils.Month.fromLuxon(DateUtils.getLuxonDate(new Date())),
                year: DateUtils.getYearFromLuxon(DateUtils.getLuxonDate(new Date()))
              };
      });
  var match$1 = ReactIO.useState(function (param) {
        return initialSelectedDates;
      });
  var setSelectedDates = match$1[1];
  var setSelectedDates$1 = function (dates) {
    return Relude_IO.flatMap((function (param) {
                  return Curry._1(onUpdate, dates);
                }), Curry._1(setSelectedDates, dates));
  };
  var tmp = {
    calendarMonth: match[0],
    layout: layout,
    selectedDates: match$1[0],
    setCalendarMonth: match[1],
    setSelectedDates: setSelectedDates$1
  };
  if (testId !== undefined) {
    tmp.testId = Caml_option.valFromOption(testId);
  }
  return React.createElement(BrowserComponents_Calendar$Stateless, tmp);
}

var make = BrowserComponents_Calendar;

exports.Styles = Styles;
exports.Stateless = Stateless;
exports.make = make;
/* wrapper Not a pure module */
